import QuestionMark from 'Assets/images/question-mark.svg';
import React from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from '~/lib/ui/popover';
import { PopupQuestionMarkHelperProps } from './index.types';

/**
 * PopupQuestionMarkHelper - Contextual help popover trigger
 *
 * Displays a question mark icon that opens a popover with additional information.
 * Fully accessible via keyboard and screen readers. Used to provide additional
 * contextual guidance wherever needed.
 *
 * @param content - Helper text displayed inside the popover
 * @param testid - Identifier used for testing purposes
 */

export const PopupQuestionMarkHelper: React.FC<PopupQuestionMarkHelperProps> = ({
  content,
  testid,
}) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="More information"
          data-testid={`${testid}-popupQuestionMark`}
          className="
            relative top-[-7px] left-[2px]
            inline-flex items-center justify-center
            h-[14px] w-[14px]
            rounded-full border border-foreground
            p-[2.5px]
            cursor-help
          "
        >
          <img src={QuestionMark} alt="help" className="w-[92%]" />
        </button>
      </PopoverTrigger>

      <PopoverContent
        side="bottom"
        align="start"
        className="min-w-[250px] p-[16px] text-[13px] leading-[21px] whitespace-pre-line"
      >
        {content}
      </PopoverContent>
    </Popover>
  );
};
